export const CONFIRMED_GET_STOCK_TRANSACTIONS = "CONFIRMED_GET_STOCK_TRANSACTIONS";
export const STOCK_TRANSACTIONS_LOADING = "STOCK_TRANSACTIONS_LOADING";
export const STOCK_TRANSACTIONS_ERROR = "STOCK_TRANSACTIONS_ERROR";